import { BreadCrumb } from 'primereact/breadcrumb';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const BillsummaryvwListPage = (props) => {
		const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, sortBy, sortOrder, apiRequestError, getPageBreadCrumbs, onSort, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	// return sum of deliverydate for the current records
	const totalDeliverydate = utils.sum(records, 'deliverydate');
	// return sum of totalamount for the current records
	const totalTotalamount = utils.sum(records, 'totalamount');
	// return sum of totalpaidamount for the current records
	const totalTotalpaidamount = utils.sum(records, 'totalpaidamount');
	// return sum of totalunpaidamount for the current records
	const totalTotalunpaidamount = utils.sum(records, 'totalunpaidamount');
	// return sum of totaldueamount for the current records
	const totalTotaldueamount = utils.sum(records, 'totaldueamount');
	// return sum of netpay for the current records
	const totalNetpay = utils.sum(records, 'netpay');
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="BillsummaryvwListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Partner Bill Summary"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 " >
                    <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                    </span>
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <FilterTags filterController={filterController} />
                    <div >
                        <PageBreadcrumbs />
                        <div className="page-records">
                            <DataTable 
                                lazy={true} 
                                loading={loading} 
                                value={records} 
                                dataKey="deliverydate" 
                                sortField={sortBy} 
                                sortOrder={sortOrder} 
                                onSort={onSort}
                                className=" p-datatable-sm" 
                                stripedRows={true}
                                showGridlines={false} 
                                rowHover={true} 
                                responsiveLayout="scroll" 
                                emptyMessage={<EmptyRecordMessage />} 
                                >
                                {/*PageComponentStart*/}
                                <Column  field="deliverydate" header="Delivery Date"   ></Column>
                                <Column  field="partneruserid" header="Partner Userid"   ></Column>
                                <Column  field="partnerid" header="Partner ID"   ></Column>
                                <Column  field="partnershopname" header="Shop Name"   ></Column>
                                <Column  field="partnershopcode" header="Shop Code"   ></Column>
                                <Column  field="totalbookings" header="Total Bookings"   ></Column>
                                <Column  field="totalamount" header="Total Amount"   ></Column>
                                <Column  field="totalpaidamount" header="Total Paid"   ></Column>
                                <Column  field="totalunpaidamount" header="Total Unpaid"   ></Column>
                                <Column  field="totaldueamount" header="Total Due"   ></Column>
                                <Column  field="netpay" header="Net Pay"   ></Column>
                                {/*PageComponentEnd*/}
                            </DataTable>
                            <div className="flex justify-content-around font-bold p-3">
                                <div>Total Deliverydate : <Chip label={totalDeliverydate} /></div><div>Total Totalamount : <Chip label={totalTotalamount} /></div><div>Total Totalpaidamount : <Chip label={totalTotalpaidamount} /></div><div>Total Totalunpaidamount : <Chip label={totalTotalunpaidamount} /></div><div>Total Totaldueamount : <Chip label={totalTotaldueamount} /></div><div>Total Netpay : <Chip label={totalNetpay} /></div>
                            </div>
                        </div>
                        <PageFooter />
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
	);
}
BillsummaryvwListPage.defaultProps = {
	primaryKey: '',
	pageName: 'billsummaryvw',
	apiPath: 'billsummaryvw/index',
	routeName: 'billsummaryvwlist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: false,
	importData: false,
	keepRecords: false,
	multiCheckbox: false,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default BillsummaryvwListPage;
